// extracted by mini-css-extract-plugin
export default {"varselMain":"varselStopp_varselMain__ACL7U","content":"varselStopp_content__zJDR9"};